<template>
  <div class="content">
    <card class="card-breadcrumb">
      <breadcrumb></breadcrumb>
      <hr/>
      <transition name="fade" mode="out-in">
        <!-- your content here -->
        <router-view></router-view>
      </transition>
    </card>
  </div>
</template>
<script>
  export default {}
</script>
<style>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .15s
  }

  .fade-enter,
  .fade-leave-to
    /* .fade-leave-active in <2.1.8 */

  {
    opacity: 0
  }
  .card-breadcrumb {
    padding: 5px;
  }
</style>
